<template>
  <div class="page" v-if="showPage">
    <navigation :customClickEvent="true" @click="showDetention">天美贷</navigation>

    <div class="result-container" v-if="['CREDIT_REFUSED'].includes(limitInfo.creditStatus) && creditRefuseGuide !== 'Y'">
      <h2 >
        审核暂未通过
      </h2>
      <p>感谢您使用天美贷，如有疑问请咨询下方天美贷官方客服电话</p>
    </div>

    <div class="landing" v-else>
      <div class="info" v-if="limitInfo.creditStatus === 'CREDIT_REVIEW'">
        <div class="wait-container">
          <vue-lottie :options="lottieOptions" ></vue-lottie>
        </div>
        <h2>授信审核中</h2>
      </div>

      <div class="info" v-else>
        <img src="https://static.ndmicro.com/tmd/landing/h5-credit/images/icon_gou@2x.png">
        <h2>恭喜您获得{{limitInfo.creditLimit}}元<template v-if="['CREDIT_REFUSED'].includes(limitInfo.creditStatus)">初审</template><template v-else>循环</template>额度</h2>
        <p v-if="['LOAN_INFO','CREDIT_SUCCESS'].includes(limitInfo.creditStatus)">额度有效期<span class="red" >60天</span></p>
      </div>

      <section class="content">
        <nd-button class="button" :class="{disabled:limitInfo.creditStatus === 'CREDIT_REVIEW'}" @click="handleDownload" data-sensors-click :disabled="limitInfo.creditStatus === 'CREDIT_REVIEW'">{{ downloadButtonTitle }}</nd-button>
        <DownloadQuestion :config="jumpPosition"/>
        <div class="add-card" @click="showTipPopOver" v-if="limitInfo.creditStatus !== 'CREDIT_REVIEW'">+ 添加绑卡</div>
      </section>
    </div>

    <download-cover v-if="isShowMask" />
    <img class="pop-over" src="https://static.ndmicro.com/tmd/landing/h5-credit/images/img_popOver.png" v-if="showPopOver">
    <ios-download v-model="downloadVisible"></ios-download>
    <ios-wxmp-dialog v-model="iosWxmpQRCodeDialogVisible"></ios-wxmp-dialog>
    <ios-wxmp-link-dialog v-model="iosWxmpLinkDialogVisible"></ios-wxmp-link-dialog>
    <web-clip-pop v-model="webclipPopVisible" @onClose="webclipPopVisible=false"/>
    <web-clip-copy-pop v-model="copyPopVisible" @onClose="copyPopVisible=false"/>
   
    <nd-dialog
      class="detention-dialog"
      v-model="detentionVisible"
      :closeBtn="true"
      :footer="false"
    >
      <div class="detention">
        <div class="confirm-btn" @click="detentionGetAmount">去拿{{limitInfo.creditLimit}}额度</div>
        <div class="cancel" @click="detentionVisible=false">放弃好运</div>
      </div>
    </nd-dialog>
  </div>
</template>


<script>
import DownloadCover from '@/components/download-cover'
import { judgeClientSystem, isWxMiniprogram, isBaiduMiniprogram } from '@/assets/utils'
import IosDownload from '@/components/ios-download'
import IosWxmpDialog from '@/components/ios-wxmp-qrcode-dialog'
import IosWxmpLinkDialog from '@/components/ios-wxmp-link-dialog'
import isIntercept from '@/assets/intercept-mixin'
import { mapActions } from 'vuex'
import waitData from '@/assets/json/wait.json'
import VueLottie from 'vue-lottie'
import WebClipPop from '../components/web-clip-pop.vue'
import WebClipCopyPop from '../components/web-clip-copy-pop.vue'
import DownloadQuestion from '@/view/landing/components/downloadQuestion.vue'
export default {
  name: 'landingGeneralResult',
  components: {
    DownloadCover,
    IosDownload,
    VueLottie,
    WebClipPop,
    WebClipCopyPop,
    IosWxmpDialog,
    IosWxmpLinkDialog,
    DownloadQuestion
  },
  data () {
    return {
      lottieOptions: {
        animationData: waitData
      },
      jumpPosition: '',
      home: this.$route.query.home, // 是否直接跳转首页，值为T
      auto: this.$route.query.auto, // 是否自动下载，值为T
      isIos: judgeClientSystem() === 'IOS',
      downloadVisible: false,
      iosWxmpQRCodeDialogVisible: false,
      iosWxmpLinkDialogVisible: false,
      showPopOver: false,
      questionDialog: false,
      detentionVisible: false,
      channel: '',
      limitInfo: {},
      showPage: false,
      webclipPopVisible: false,
      copyPopVisible: false
    }
  },

  async created () {
    this.$bus.$emit('ready')
    this.channel = this.$route.query.channel || this.$storage.get('channel') || 'official'
    await isIntercept(this.channel)


    this.getLimit()
    this.$once('hook:beforeDestroy', () => {
      clearTimeout(window.timer)
    })
  },
  computed: {
    downloadButtonTitle () {
      if (isWxMiniprogram() || isBaiduMiniprogram()) {
        return '点击复制链接到浏览器打开'
      }
      return '立即领取额度'
    }
  },
  beforeDestroy () {
    clearTimeout(window.timer)
  },
  methods: {
    ...mapActions('authentication', ['channelConfigX']),
    ...mapActions('user', ['getChannelJumpX', 'getLimitX']),
    async getLimit () {
      const { success, data } = await this.getLimitX({ loanPlatform: 'TMD' })
      if (success) {
        this.limitInfo = data
        if (data.creditStatus === 'CREDIT_REVIEW') {
          window.timer = setTimeout(() => {
            this.getLimit()
          }, 5000)
        } else {
          await this.getChannelJump(data.creditStatus)
          if (this.jumpPosition !== 'RJ') {
            const configRes = await this.channelConfigX(
              { channelNo: this.channel }
            )

            const { creditRefuseGuide, autoDownload } = configRes.data || {}

            if (this.jumpPosition === 'H5' && judgeClientSystem() === 'IOS') {
              return this.$router.replace('/')
            }

            if (configRes.success && autoDownload === 'Y' && !this.isShowMask && creditRefuseGuide === 'Y') {
              this.handleDownload()
            }
            if (configRes.success && configRes.data?.autoHome === 'Y') {
              return this.$router.replace('/')
            }
          }
          clearTimeout(window.timer)
        }
        this.showPage = true
      }
    },

    async getChannelJump (creditStatus) {
      const params = { channel: this.channel }
      if (creditStatus === 'CREDIT_REFUSED') {
        params.creditStatus = creditStatus
      }
      const { success, data } = await this.getChannelJumpX(params)
      if (success) {
        this.jumpPosition = data.jumpPosition
      }
    },

    handleDownload () {
      this.downloadApp()
    },
  
    copyAndroidDownloadLink () {
      this.copyUrlAndToast()
    },
    showDetention () {
      this.detentionVisible = true
      this.$sensors.track('PopupDisplay', { msg_name: '返回挽留弹窗' })
    },
    detentionGetAmount () {
      this.detentionVisible = false
      this.handleDownload()
    },
    showTipPopOver () {
      if (this.showPopOver) { return }
      this.showPopOver = true
      setTimeout(() => {
        this.showPopOver = false
      }, 2000)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

@keyframes rotate {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes popOverAlpha {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.result-container{
  height: 1449px;
  min-height: calc(100vh - 110px);
  background: url(https://static.ndmicro.com/tmd/landing/h5-credit/images/result2.png) no-repeat;
  background-size: 100% 1449px;
  text-align: center;
  padding: 650px 100px 0;
  width: 100%;
  overflow: hidden;
  position: relative;
  &:after{
    content: "";
    position: absolute;
    width:10rem;
    height:168px;
    background: url("https://static.ndmicro.com/tmd/landing/h5-credit/images/img_b@2x.png") no-repeat;
    background-size: 100% 100%;
    left: 0;
    bottom: 0;
  }
  h2 {
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 56px;
  }
  p {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
    margin-top: 10px;
  }
}
.landing {
  height: 1715px;
  background-image: url('https://static.ndmicro.com/tmd/landing/h5-credit/images/rbg.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  .ask-container {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF4633;
    line-height: 33px;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .info {
    padding-top: 150px;
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-bottom: 390px;
    height: 400px;
    img{
      width: 120px;
    }
    h2 {
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      padding: 10px 0;
    }
    p {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    span.red {
      color: #FF4633;
    }
  }

  .content {
    width: 100%;
    margin: 0 auto;
    .button {
      width: 570px;
      height: 94px;
      line-height: 94px;
      text-align: center;
      font-size: 40px;
      color: white;
      margin: 0 auto;
      font-weight: bold;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      box-shadow: 0px 14px 20px 4px #FCD4CF;
      border-radius: 47px;
      animation: rotate 1s linear infinite;
      &.disabled {
        animation: null;
        box-shadow: none;
      }
    }
    .question {
      font-size: 24px;
      font-weight: 400;
      color: #FF4633;
      height: 33px;
      line-height: 33px;
      text-align: center;
      margin-top: 30px;
      img {
        padding-left: 5px;
      }
    }
    .add-card {
      width: 690px;
      height: 94px;
      background: #FFFFFF;
      box-shadow: 0px 14px 20px 0px rgba(219,219,219,0.5);
      border-radius: 20px;
      font-size: 32px;
      font-weight: 400;
      color: #283D7D;
      line-height: 94px;
      text-align: center;
      margin: 265px auto;
    }
  }
}

.pop-over {
      width: 319px;
      height: 70px;
      position: relative;
      bottom: 1012px;
      left: 216px;
      animation: popOverAlpha 0.25s ease-in-out;
    }

.question-dialog {
  /deep/.default-content {
    padding-top: 0;
  }
  .question {
    background-image: url(https://static.ndmicro.com/tmd/landing/h5-credit/images/img_question_pop.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    width: 620px;
    height: 650px;
    padding-top: 505px;
    .copy-btn {
      width: 440px;
      height: 80px;
      background: linear-gradient(90deg, #FF7831 0%, #FFC994 100%);
      box-shadow: 0px 14px 20px 4px #E8EDFF;
      border-radius: 40px;
      font-size: 36px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 80px;
      text-align: center;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 40px;
        height: 40px;
      }
      span {
        padding-left: 10px;
      }
    }
  }
}

.detention-dialog {
  /deep/.default-content {
    padding-top: 0;
  }

  .detention {
    background-image: url(https://static.ndmicro.com/tmd/landing/h5-credit/images/img_detention_pop.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    width: 620px;
    height: 680px;
    padding-top: 490px;
    text-align: center;
    .confirm-btn {
      width: 440px;
      height: 80px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      box-shadow: 0px 14px 20px 4px #FCD4CF;
      border-radius: 40px;
      text-align: center;
      font-size: 36px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 80px;
      margin: 0 auto;
    }
    .cancel {
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      line-height: 33px;
      margin-top: 38px;
    }
  }
}
</style>